import httpClient from "@/auth/http-client";
import { 
  ILinkedProductCategory, 
  ILinkedProductCategoryBatch 
} from "@/interfaces/linked-product-category.interface";

class LinkedProductCategoryService {
  private baseUrl = "/api/v1/linkedproductcategory";

  async getByProductId(productId: number): Promise<ILinkedProductCategory[]> {
    return await httpClient.get(`${this.baseUrl}/product/${productId}`);
  }

  async deleteByCategory(productId: number, categoryId: number): Promise<void> {
    await httpClient.delete(`${this.baseUrl}?productId=${productId}&categoryId=${categoryId}`);
  }

  async saveBatch(data: ILinkedProductCategoryBatch): Promise<void> {
    await httpClient.post(`${this.baseUrl}/batch-categories`, data);
  }
}

export default new LinkedProductCategoryService();
